export default __webpack_public_path__ + "static/media/icon-insights-performance-calls-to-online-orders.654b9b6f.svg";